import { mapSlice } from './map.slice.ts';

export const { updateMapInfo, resetMap } = mapSlice.actions;
